import React from "react";
import { useField } from "formik";
import { RichTextField } from "common/fields/RichTextField";

interface IFormikPreviewFormRichTextProps {
  name: string;
}
export const FormikPreviewFormRichText: React.FC<
  IFormikPreviewFormRichTextProps
> = ({ name }) => {
  const [field, , helpers] = useField<string>({
    name,
  });

  return (
    <RichTextField
      initialValue={field.value}
      onChange={(value) => helpers.setValue(value)}
    />
  );
};
